import Pagination from './Pagination';

const DataTablePagination = ({ url, paginator }: any) => (
  <Pagination url={url} paginator={paginator} />
);

export default DataTablePagination;
